// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td.expandable {
  width: 100%;
  float: left;
  clear: left;
}

.fake-row {
  display: table-row;
}`, "",{"version":3,"sources":["webpack://./src/app/s1/s1-expandable-row/s1-expandable-row.component.scss"],"names":[],"mappings":"AAAA;EAAe,WAAA;EAAW,WAAA;EAAW,WAAA;AAIrC;;AAHA;EACE,kBAAA;AAMF","sourcesContent":["td.expandable {width:100%;float:left;clear:left}\n.fake-row { \n  display: table-row; \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
